/* Bookshelf Treasures — display-only approximate currency converter.
   Active only while the store is single-currency (USD). Converts tagged
   [data-bt-money] prices client-side using live FX rates. Checkout stays USD. */
(function () {
  // The snippet renders more than once (beside the wordmark on mobile, in the
  // actions row on desktop, and in the slide-in menu). This used to bind only
  // querySelector's first match, so on mobile the one buyers could actually see
  // was dead — picking USD did nothing and prices stayed in the geo currency.
  var wraps = [].slice.call(document.querySelectorAll('[data-bt-cur]'));
  if (!wraps.length) return;
  var wrap = wraps[0];
  var sels = [].slice.call(document.querySelectorAll('[data-bt-cur-select]'));
  var sel = sels[0];
  var SYM = { USD: '$', GBP: '£', EUR: '€', CAD: 'CA$', AUD: 'AU$', NZD: 'NZ$',
              INR: '₹', JPY: '¥', SGD: 'S$', AED: 'AED ', CHF: 'CHF ' };
  // Currencies conventionally shown without decimals.
  var ZERO_DP = { JPY: 1 };
  var rates = { USD: 1 };

  function format(cur, usd) {
    var v = usd * (rates[cur] || 1);
    var s = ZERO_DP[cur] ? Math.round(v).toLocaleString() : v.toFixed(2);
    return (SYM[cur] || cur + ' ') + s;
  }
  function convert(cur) {
    document.querySelectorAll('[data-bt-money]').forEach(function (n) {
      var usd = parseFloat(n.getAttribute('data-bt-money'));
      if (isNaN(usd)) return;
      n.textContent = cur === 'USD' ? '$' + usd.toFixed(2) : format(cur, usd);
    });
    document.querySelectorAll('[data-bt-cur-note]').forEach(function (el) { el.hidden = cur === 'USD'; });
  }
  function ensureRates(cur, cb) {
    if (cur === 'USD' || rates[cur]) return cb();
    var cache;
    try { cache = JSON.parse(localStorage.getItem('bt_fx') || 'null'); } catch (e) {}
    if (cache && cache.rates && (Date.now() - cache.t < 864e5)) { rates = cache.rates; return cb(); }
    fetch('https://open.er-api.com/v6/latest/USD')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (d && d.rates) {
          rates = d.rates;
          try { localStorage.setItem('bt_fx', JSON.stringify({ t: Date.now(), rates: rates })); } catch (e) {}
        }
        cb();
      })
      .catch(cb);
  }

  // Default to the visitor's own currency (from their country), unless they've
  // explicitly picked one before — an explicit choice always wins.
  var geo = wrap.getAttribute('data-bt-cur-geo') || 'USD';
  var stored = null;
  try { stored = localStorage.getItem('bt_currency'); } catch (e) {}
  if (stored && !SYM[stored]) stored = null;          // ignore stale/unknown codes
  var active = stored || geo;
  sels.forEach(function (s) { s.value = active; });

  function apply(cur) {
    active = cur;
    try { localStorage.setItem('bt_currency', cur); } catch (e) {}
    sels.forEach(function (s) { if (s.value !== cur) s.value = cur; });  // keep every copy in step
    ensureRates(cur, function () { convert(cur); });
  }
  sels.forEach(function (s) {
    s.addEventListener('change', function () { apply(s.value); });
  });

  if (active !== 'USD') ensureRates(active, function () { convert(active); });

  /* Re-convert prices injected after load (predictive search, cart drawer, etc.).
     Without this, dynamically rendered prices stay in USD while the page shows GBP. */
  window.btCurrency = {
    get code() { return active; },
    refresh: function () {
      if (active === 'USD') { convert('USD'); return; }
      ensureRates(active, function () { convert(active); });
    }
  };
})();
